export enum OrderOperationType {
  /** Покупка бумаг */
  SecuritiesPurchase = 'SecuritiesPurchase',
  /** Продажа бумаг */
  SecuritiesSale = 'SecuritiesSale',
  /** Списание ценных бумаг */
  SecuritiesWithdrawal = 'SecuritiesWithdrawal',
  /** Зачисление ценных бумаг */
  SecuritiesDeposit = 'SecuritiesDeposit',
}
